import * as React from 'react';

export const PlaceholderRegistrationDocumentV2 = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 596.2 298.7" {...props}>
		<path fill="currentColor" d="M0 0h179.6v298.7H0z" data-name="Rechteck 2" opacity=".4" />
		<path fill="currentColor" d="M179.3 0h208.6v298.7H179.3z" data-name="Rechteck 3" opacity=".4" />
		<path fill="currentColor" d="M387.6 0h208.6v298.7H387.6z" data-name="Rechteck 4" opacity=".4" />
		<g fill="currentColor" data-name="Gruppe 5" transform="translate(-100.2 -90.6)">
			<path
				d="M263 231.8H113.5v-22.2H263zm-148.4-1h147.3v-20.1H114.6z"
				data-name="Pfad 1"
				opacity=".4"
			/>
			<path d="M114.1 251.4h49.2v6.2h-49.2z" data-name="Rechteck 7" opacity=".4" />
			<path d="M114.1 277.3h73.8v6.2h-73.8z" data-name="Rechteck 8" opacity=".4" />
			<path d="M114.1 305.1h99.1v6.2h-99.1z" data-name="Rechteck 9" opacity=".4" />
			<path d="M114.1 108.6h149.7v6.2H114.1z" data-name="Rechteck 10" opacity=".4" />
			<g data-name="Gruppe 4">
				<path d="M503.3 108.6h12v6.2h-12z" data-name="Rechteck 11" opacity=".4" />
				<path d="M530.5 108.6h20.6v6.2h-20.6z" data-name="Rechteck 12" opacity=".4" />
				<path d="M561.6 108.6h20.6v6.2h-20.6z" data-name="Rechteck 13" opacity=".4" />
				<path d="M586.9 108.6h31.3v6.2h-31.3z" data-name="Rechteck 14" opacity=".4" />
				<path d="M645.9 108.6h31.3v6.2h-31.3z" data-name="Rechteck 15" opacity=".4" />
				<path d="M503.3 121.9h68.2v6.2h-68.2z" data-name="Rechteck 16" opacity=".4" />
				<path d="M623.1 121.9h40.1v6.2h-40.1z" data-name="Rechteck 17" opacity=".4" />
				<path d="M623.1 135.2h40.1v6.2h-40.1z" data-name="Rechteck 18" opacity=".4" />
				<path d="M503.3 135.2h68.1v6.2h-68.1z" data-name="Rechteck 19" opacity=".4" />
				<path d="M573.9 148.5h23v6.2h-23z" data-name="Rechteck 20" opacity=".4" />
				<path d="M573.9 161.8h34.6v6.2h-34.6z" data-name="Rechteck 21" opacity=".4" />
				<path d="M633.8 161.8h43.4v6.2h-43.4z" data-name="Rechteck 22" opacity=".4" />
				<path d="M513.6 161.8h37.1v6.2h-37.1z" data-name="Rechteck 23" opacity=".4" />
				<path d="M573.9 201.8h34.6v6.2h-34.6z" data-name="Rechteck 24" opacity=".4" />
				<path d="M633.8 201.8h25.1v6.2h-25.1z" data-name="Rechteck 25" opacity=".4" />
				<path d="M513.6 201.8h25.9v6.2h-25.9z" data-name="Rechteck 26" opacity=".4" />
				<path d="M573.9 215.1h34.6v6.2h-34.6z" data-name="Rechteck 27" opacity=".4" />
				<path d="M620 215.1h14.1v6.2H620z" data-name="Rechteck 28" opacity=".4" />
				<path d="M513.6 215.1h37.8v6.2h-37.8z" data-name="Rechteck 29" opacity=".4" />
				<path d="M573.9 175.1h43.4v6.2h-43.4z" data-name="Rechteck 30" opacity=".4" />
				<path d="M513.6 175.1h37.1v6.2h-37.1z" data-name="Rechteck 31" opacity=".4" />
				<path d="M573.9 188.5h34.6v6.2h-34.6z" data-name="Rechteck 32" opacity=".4" />
				<path d="M513.6 188.5h37.1v6.2h-37.1z" data-name="Rechteck 33" opacity=".4" />
				<path d="M513.6 228.4h99v6.2h-99z" data-name="Rechteck 34" opacity=".4" />
				<path d="M513.6 241.7h99v6.2h-99z" data-name="Rechteck 35" opacity=".4" />
				<path d="M513.6 268.3h53.9v6.2h-53.9z" data-name="Rechteck 36" opacity=".4" />
				<path d="M630.8 268.3H659v6.2h-28.2z" data-name="Rechteck 37" opacity=".4" />
				<path d="M513.6 281.7H659v6.2H513.6z" data-name="Rechteck 38" opacity=".4" />
				<path d="M513.6 295h54.6v6.2h-54.6z" data-name="Rechteck 39" opacity=".4" />
				<path d="M587.3 295h13.8v6.2h-13.8z" data-name="Rechteck 40" opacity=".4" />
				<path d="M617.2 295h63.1v6.2h-63.1z" data-name="Rechteck 41" opacity=".4" />
				<g data-name="Gruppe 1">
					<path d="M294.9 108.6H341v6.2h-46.1z" data-name="Rechteck 42" opacity=".4" />
					<path d="M360 108.6h38v6.2h-38z" data-name="Rechteck 43" opacity=".4" />
					<path d="M411.1 108.6H469v6.2h-57.9z" data-name="Rechteck 44" opacity=".4" />
				</g>
				<g data-name="Gruppe 2">
					<path d="M294.9 121.9h22.2v6.2h-22.2z" data-name="Rechteck 45" opacity=".4" />
					<path d="M446.8 121.9H469v6.2h-22.2z" data-name="Rechteck 46" opacity=".4" />
				</g>
				<path d="M446.8 135.2H469v6.2h-22.2z" data-name="Rechteck 47" opacity=".4" />
				<path d="M294.9 148.5h98v6.2h-98z" data-name="Rechteck 48" opacity=".4" />
				<path d="M294.9 161.8h20.3v6.2h-20.3z" data-name="Rechteck 49" opacity=".4" />
				<path d="M294.9 175.1h58v6.2h-58z" data-name="Rechteck 50" opacity=".4" />
				<path d="M294.9 188.5h149.8v6.2H294.9z" data-name="Rechteck 51" opacity=".4" />
				<path d="M294.9 201.8h13.4v6.2h-13.4z" data-name="Rechteck 52" opacity=".4" />
				<path d="M294.9 215.1h39.8v6.2h-39.8z" data-name="Rechteck 53" opacity=".4" />
				<path d="M294.9 228.4h57.3v6.2h-57.3z" data-name="Rechteck 54" opacity=".4" />
				<path d="M294.9 241.7H444v6.2H294.9z" data-name="Rechteck 55" opacity=".4" />
				<path d="M294.9 255h136.2v6.2H294.9z" data-name="Rechteck 56" opacity=".4" />
				<path d="M294.9 268.3h135.9v6.2H294.9z" data-name="Rechteck 57" opacity=".4" />
				<path d="M294.9 281.7h148.7v6.2H294.9z" data-name="Rechteck 58" opacity=".4" />
				<path d="M294.9 321.6h385.4v6.2H294.9z" data-name="Rechteck 59" opacity=".4" />
				<path d="M294.9 334.9h385.4v6.2H294.9z" data-name="Rechteck 60" opacity=".4" />
				<path d="M294.9 348.2h225.7v6.2H294.9z" data-name="Rechteck 61" opacity=".4" />
				<g data-name="Gruppe 3">
					<path d="M294.9 308.3h35.4v6.2h-35.4z" data-name="Rechteck 62" opacity=".4" />
					<path d="M434.5 308.3h34.4v6.2h-34.4z" data-name="Rechteck 63" opacity=".4" />
					<path d="M365.5 308.3h34v6.2h-34z" data-name="Rechteck 64" opacity=".4" />
				</g>
				<path d="M294.9 295h35.9v6.2h-35.9z" data-name="Rechteck 65" opacity=".4" />
			</g>
			<path d="M114.1 316.5h99.1v6.2h-99.1z" data-name="Rechteck 66" opacity=".4" />
			<path d="M114.1 348.2h32.6v6.2h-32.6z" data-name="Rechteck 67" opacity=".4" />
			<path d="M206.2 348.2h56.3v6.2h-56.3z" data-name="Rechteck 68" opacity=".4" />
			<ellipse
				cx="14.5"
				cy="9.2"
				data-name="Ellipse 1"
				opacity=".4"
				rx="14.5"
				ry="9.2"
				transform="translate(176.2 125.3)"
			/>
		</g>
		<g fill="currentColor" opacity=".6">
			<path
				d="M51.4 133.3h-4.3l-.9 2.5h-1.8l4.1-11.4h1.4l4.1 11.4h-1.8zm-.5-1.5l-1.6-5-1.6 5z"
				data-name="Pfad 2"
			/>
			<path
				d="M56.5 124.4h4.4a3.6 3.6 0 012.5.8 3 3 0 01.9 2.2 2.8 2.8 0 01-.3 1.3 2.7 2.7 0 01-.5.6 2.2 2.2 0 01-.8.5 2.4 2.4 0 011.4 1 3.2 3.2 0 01.4 1.6 2.9 2.9 0 01-.9 2.3 3 3 0 01-2.2.9h-4.8v-11.2zm1.7 1.6v3.3h2.5a2 2 0 001.4-.5 1.6 1.6 0 00.5-1.1 1.8 1.8 0 00-.5-1.2 2 2 0 00-1.4-.5zm0 4.8v3.4h2.7a2 2 0 001.4-.5 2 2 0 000-2.4 2 2 0 00-1.4-.5z"
				data-name="Pfad 3"
			/>
			<path
				d="M85.2 132.6a3.6 3.6 0 01-1.4 2.4 3.8 3.8 0 01-2.6.8 3.2 3.2 0 01-2.2-.7 3.4 3.4 0 01-1.3-1.4l-.2-.5-.2-.6a16.4 16.4 0 01-.1-2.6 17.9 17.9 0 01.1-2.7 3.6 3.6 0 01.4-1.1 4.3 4.3 0 011.3-1.4 3.8 3.8 0 012.2-.6 3.6 3.6 0 012.7 1 4 4 0 011.3 2.4h-1.8a2.3 2.3 0 00-.8-1.2 2.4 2.4 0 00-1.4-.5 2.5 2.5 0 00-1 .2 4.3 4.3 0 00-.7.6 1.5 1.5 0 00-.4.9 26.5 26.5 0 000 4.6 3 3 0 00.4 1 4.3 4.3 0 00.7.6 1.7 1.7 0 001 .3 2.3 2.3 0 002.2-1.6h1.8z"
				data-name="Pfad 4"
			/>
			<path
				d="M87.6 124.4h4a4 4 0 013.5 1.9 2.4 2.4 0 01.5 1.3 14.9 14.9 0 01.1 2.4 17.1 17.1 0 01-.1 2.6 1.9 1.9 0 01-.2.7l-.3.6a3.5 3.5 0 01-1.4 1.3 3.8 3.8 0 01-2.2.6h-3.9v-11.4zm1.7 9.8h2.1a2.2 2.2 0 002.1-1 2.5 2.5 0 00.4-.9l.1-2.1a11 11 0 00-.1-2.1 2.4 2.4 0 00-2.4-2h-2.1v8.1z"
				data-name="Pfad 5"
			/>
			<path d="M99.2 127.4v-1.7l1.6-1.2h1.6v11.4h-1.6v-9.7z" data-name="Pfad 6" />
			<path
				d="M107.1 134.3l4.4-5.6a2 2 0 00.4-.6 4.3 4.3 0 01.1-.5 1.5 1.5 0 00-.4-1.1 1.7 1.7 0 00-1.2-.5 1.5 1.5 0 00-1.1.4 1.7 1.7 0 00-.5 1.2h-1.6a3.7 3.7 0 011-2.4 3 3 0 012.2-.9 3.2 3.2 0 012.4.9 3.2 3.2 0 01.9 2.3 2.9 2.9 0 01-.7 2l-3.7 4.6h4.4v1.6h-6.5v-1.4z"
				data-name="Pfad 7"
			/>
			<path
				d="M118.3 129.2h.6a1.7 1.7 0 001.3-.5 1.7 1.7 0 00-1.2-2.9 2 2 0 00-1 .3 1.7 1.7 0 00-.6 1h-1.6a3.2 3.2 0 011-2.1 2.9 2.9 0 012.1-.9 3.2 3.2 0 012.5 1 3.1 3.1 0 01.9 2.2 5.9 5.9 0 01-.2 1.3 2.6 2.6 0 01-1 1.1 2.6 2.6 0 011 1.1 3.2 3.2 0 01.3 1.4 3 3 0 01-1 2.5 3.6 3.6 0 01-2.5 1 2.8 2.8 0 01-2.1-.8 3.6 3.6 0 01-1.2-2.2h1.6a2 2 0 00.6.9 1.8 1.8 0 001.1.4 1.7 1.7 0 001.2-.5 2 2 0 000-2.6 1.7 1.7 0 00-1.2-.5h-.7v-1.2z"
				data-name="Pfad 8"
			/>
			<path
				d="M124.5 132.6l3.8-8.2h1.8l-3.9 8.2h3v-3.3h1.6v3.3h.9v1.5h-.9v1.7h-1.6v-1.7h-4.8v-1.5z"
				data-name="Pfad 9"
			/>
		</g>
		<g fill="currentColor" opacity=".6">
			<path
				d="M194.7 46l.2 2.6.5-1.9.2-.3.4-.1a.6.6 0 01.4.1l.2.3.5 1.9.2-2.6h-.1l-.4-.1-.1-.4.1-.4.4-.1h1.1l.4.1.1.4-.1.4-.4.1h-.1l-.4 3.9-.1.3a.4.4 0 01-.3.1h-.2a.4.4 0 01-.3-.1l-.2-.4-.8-2.6-.8 2.6-.2.3-.3.1h-.2l-.3-.1a.4.4 0 01-.1-.3l-.4-3.9h-.1l-.4-.1-.1-.4.1-.4.4-.1h1.1l.4.1.1.4-.1.4-.4.1h.1z"
				data-name="Pfad 10"
			/>
			<path
				d="M202 44.6a2 2 0 011.6.8 4 4 0 010 4.2 2 2 0 01-3.2 0 4 4 0 010-4.2 2 2 0 011.6-.8zm.1 1a.8.8 0 00-.7.5 3.4 3.4 0 000 2.8c.2.3.4.5.7.5a.8.8 0 00.7-.5 3.4 3.4 0 000-2.8c-.2-.3-.4-.5-.7-.5z"
				data-name="Pfad 11"
			/>
			<path
				d="M207.7 46v3.3h2v-.8l.1-.4.4-.1.4.1.1.4v1.3l-.1.3-.4.1h-4l-.4-.1-.1-.4.1-.4.4-.1h.4v-3.3h-.4l-.4-.1-.1-.4.1-.4.4-.1h1.9l.4.1.1.4-.1.4-.4.1h-.4z"
				data-name="Pfad 12"
			/>
			<path
				d="M214.2 44.6a2 2 0 011.6.8 4 4 0 010 4.2 2 2 0 01-3.2 0 4 4 0 010-4.2 2 2 0 011.6-.8zm0 1a.8.8 0 00-.7.5 3.4 3.4 0 000 2.8c.2.3.4.5.7.5a.8.8 0 00.7-.5 3.4 3.4 0 000-2.8.8.8 0 00-.7-.5z"
				data-name="Pfad 13"
			/>
			<path
				d="M220.3 44.6a2 2 0 011.6.8 4 4 0 010 4.2 2 2 0 01-3.2 0 4 4 0 010-4.2 2 2 0 011.6-.8zm0 1a.8.8 0 00-.7.5 3.4 3.4 0 000 2.8c.2.3.4.5.7.5a.8.8 0 00.7-.5 3.4 3.4 0 000-2.8c-.2-.3-.4-.5-.7-.5z"
				data-name="Pfad 14"
			/>
			<path
				d="M226.3 44.6a2 2 0 011.6.8 4 4 0 010 4.2 2 2 0 01-3.2 0 4 4 0 010-4.2 2 2 0 011.6-.8zm.1 1a.8.8 0 00-.7.5 3.4 3.4 0 000 2.8c.2.3.4.5.7.5a.8.8 0 00.7-.5 3.4 3.4 0 000-2.8c-.2-.3-.4-.5-.7-.5z"
				data-name="Pfad 15"
			/>
			<path
				d="M232.4 44.6a2 2 0 011.6.8 4 4 0 010 4.2 2 2 0 01-3.2 0 4 4 0 010-4.2 2 2 0 011.6-.8zm0 1a.8.8 0 00-.7.5 3.4 3.4 0 000 2.8c.2.3.4.5.7.5a.8.8 0 00.7-.5 3.4 3.4 0 000-2.8.8.8 0 00-.7-.5z"
				data-name="Pfad 16"
			/>
			<path
				d="M237.7 45.7v1a1 1 0 01.5-.1h.4a1.9 1.9 0 011.3.5 2 2 0 01.5 1.4 2 2 0 01-.6 1.5 2.9 2.9 0 01-1.7.5 3.3 3.3 0 01-1.2-.2.5.5 0 01-.4-.5.6.6 0 01.1-.4.5.5 0 01.4-.2 1.8 1.8 0 01.6.1 2 2 0 00.7.1 1.1 1.1 0 00.8-.3 1 1 0 00-.7-1.7 2.5 2.5 0 00-.7.2l-.5.2-.4-.1-.1-.5v-2.1l.1-.3a.3.3 0 01.2-.1h2.9l.4.1.1.4-.1.4-.4.1h-2.2z"
				data-name="Pfad 17"
			/>
			<path
				d="M245.2 49.3h.7l.4.1.1.4-.1.4-.4.1h-2.6l-.4-.1-.1-.4.1-.4.4-.1h.8v-3.7l-.5.1h-.3a.4.4 0 01-.3-.7l.3-.2 1.1-.3.2-.1h.1a.4.4 0 01.3.1l.1.3v4.5z"
				data-name="Pfad 18"
			/>
			<path
				d="M252.1 46h-.9v3.3h.7l.4.1.1.4-.1.4-.4.1h-2.6l-.4-.1-.1-.4.1-.4.4-.1h.7V46h-.9v1l-.1.3a.4.4 0 01-.3.1l-.4-.1-.1-.4v-1.3l.1-.5.4-.1h3.8l.4.1.1.5v1.3l-.1.4-.4.1-.3-.1-.1-.4z"
				data-name="Pfad 19"
			/>
			<path
				d="M256.1 49.3h1.5l.1-.3.4-.1a.4.4 0 01.4.4v.8a.4.4 0 01-.1.3.3.3 0 01-.2.1H255l-.4-.1a.5.5 0 010-.6l.3-.3 1.8-1.7a2 2 0 00.4-.6 1.3 1.3 0 00.1-.6.7.7 0 00-.8-.8l-.4.1-.3.2a.3.3 0 00-.1.2.6.6 0 01-.5.3l-.3-.1-.1-.4.1-.4.3-.3a1 1 0 01.7-.3 2.2 2.2 0 01.8-.1 1.7 1.7 0 011.3.4 1.7 1.7 0 01.5 1.2 2 2 0 01-.3 1 3.2 3.2 0 01-.8.9z"
				data-name="Pfad 20"
			/>
			<path
				d="M263.5 49.3h.7l.4.1.1.4-.1.4-.4.1h-2.6l-.4-.1-.1-.4.1-.4.4-.1h.8v-3.7l-.5.1h-.3a.4.4 0 01-.3-.7l.3-.2 1.1-.3.2-.1h.1a.4.4 0 01.3.1l.1.3v4.5z"
				data-name="Pfad 21"
			/>
			<path
				d="M268.3 49.3h1.5l.1-.3.4-.1a.4.4 0 01.4.4v.8a.4.4 0 01-.1.3.3.3 0 01-.2.1h-3.2l-.4-.1a.5.5 0 010-.6l.3-.3 1.8-1.7a2 2 0 00.4-.6 1.3 1.3 0 00.1-.6.7.7 0 00-.8-.8l-.4.1-.3.2a.3.3 0 00-.1.2.6.6 0 01-.5.3l-.3-.1-.1-.4.1-.4.3-.3a1 1 0 01.7-.3 2.2 2.2 0 01.8-.1 1.7 1.7 0 011.3.4 1.7 1.7 0 01.5 1.2 2 2 0 01-.3 1 3.2 3.2 0 01-.8.9z"
				data-name="Pfad 22"
			/>
			<path
				d="M275.7 47.3a2.2 2.2 0 01.8.5c.2.2.2.5.2.9a1.6 1.6 0 01-.6 1.3 2.5 2.5 0 01-1.5.5 2.8 2.8 0 01-1.3-.3c-.4-.2-.5-.4-.5-.6l.1-.3.4-.1a4 4 0 01.6.2 3 3 0 00.8.2.8.8 0 00.6-.2 1 1 0 00.2-.6.8.8 0 00-.2-.6 1.2 1.2 0 00-.7-.2l-.4-.1-.1-.4a.4.4 0 01.4-.4h.1a.8.8 0 00.6-.2.7.7 0 00.1-.5.7.7 0 00-.7-.7 1.9 1.9 0 00-.7.2 4 4 0 01-.6.2.4.4 0 01-.4-.4.7.7 0 01.5-.6 2.5 2.5 0 011.3-.3 1.6 1.6 0 011.2.4 1.4 1.4 0 01.5 1 1.4 1.4 0 01-.2.7c.1.1-.2.2-.5.4z"
				data-name="Pfad 23"
			/>
			<path
				d="M282.2 48.1a.4.4 0 00.3-.1l.2-.1a.4.4 0 01.3.1l.1.3v.2l-.1.3-.1.1h-.7v.5h.5a.4.4 0 01.4.4l-.1.3-.4.1h-1.9l-.4-.1a.4.4 0 01-.1-.3l.1-.3.4-.1h.6v-.5h-2l-.2-.1a.3.3 0 01-.1-.2v-.5l.1-.2 1.8-3.1a.1.1 0 01.1-.1h.3l.8.1a.1.1 0 01.1.1v3.2zm-1-2.4l-1.4 2.4h1.4z"
				data-name="Pfad 24"
			/>
			<path
				d="M286.3 45.7v1a1 1 0 01.5-.1h.4a1.9 1.9 0 011.3.5 2 2 0 01.5 1.4 2 2 0 01-.6 1.5 2.9 2.9 0 01-1.7.5 3.3 3.3 0 01-1.2-.2.5.5 0 01-.4-.5.6.6 0 01.1-.4.5.5 0 01.4-.2 1.8 1.8 0 01.6.1 2 2 0 00.7.1 1.1 1.1 0 00.8-.3 1 1 0 00-.7-1.7 2.5 2.5 0 00-.7.2l-.5.2-.4-.1-.1-.5v-2.1l.1-.3a.3.3 0 01.2-.1h2.9l.4.1.1.4-.1.4-.4.1h-2.2z"
				data-name="Pfad 25"
			/>
			<path
				d="M292.3 47.2a1 1 0 01.5-.4 1.3 1.3 0 01.6-.1 1.7 1.7 0 011.2.5 2.1 2.1 0 01.5 1.3 1.7 1.7 0 01-1.9 1.9 1.8 1.8 0 01-1.5-.7 2.9 2.9 0 01-.5-1.9 3.6 3.6 0 01.8-2.4 3 3 0 012.2-.9 1.5 1.5 0 01.7.1.2.2 0 01.2.2c0 .3-.2.4-.6.4h-.4a1.4 1.4 0 00-1.1.5 3 3 0 00-.7 1.5zm1.7 1.4a1.4 1.4 0 00-.2-.7.8.8 0 00-1.2 0 .8.8 0 00-.2.7 1.4 1.4 0 00.2.7.8.8 0 001.2 0 .8.8 0 00.2-.7z"
				data-name="Pfad 26"
			/>
		</g>
	</svg>
);
